import React from "react";
import { Trans } from "react-i18next";
import styled from "styled-components";
import { t } from "js/i18n";

const SalesLink = styled.a`
    color: #11a9e2;
`;

const SalesText = styled.div`
    float: left;
    color: #6d6d6d;
    letter-spacing: 0.1px;
    margin-top: 15px;
    font-size: 14px;
`;
export function TeamCheckoutSalesLink() {
    return (
        <SalesText>
            <Trans
                i18nKey="Interested in a custom trial? <salesLink>Contact sales</salesLink>"
                components={{ salesLink: <SalesLink href="mailto:sales@beautiful.ai" /> }}
            />
        </SalesText>
    );
}
